<template>
    <div class="HomeLayout" v-if="UserPrivateProfile.UserId">
        <div>
            <nav class="navbar navbar-light navbar-expand-md navigation-clean">
                <div class="container-fluid">
                    <a id="navbar-brand" class="navbar-brand pointer"><img v-bind:src="sitelogo" /></a>
                    <div style="float:right;">
                        <b-navbar-toggle target="nav-collapse" style="margin-top:1rem;" right></b-navbar-toggle>
                        <b-collapse id="nav-collapse" is-nav right>
                            <b-navbar-nav pills right variant="light">
                                <b-nav-item class="hidden" role="presentation"></b-nav-item>
                                <b-nav-item><Logout /></b-nav-item>
                            </b-navbar-nav>
                        </b-collapse>
                    </div>
                </div>
            </nav>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4" v-for="module in AppModules">
                    <a v-if="module.ExternalUrl" :href="module.ExternalUrl">
                        <div class="paper">
                            <h3 class="center-text">{{ module.Label }}</h3>
                            <p class="center-text">{{ module.Message }}</p>
                        </div>
                    </a>
                    <router-link v-else :to="'/' + module.Link">
                        <div class="paper">
                            <h3 class="center-text">{{ module.Label }}</h3>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <!--Logged in User-->
        <p class="upper-right" v-if="UserPrivateProfile.FirstName">Logged in as: {{ UserPrivateProfile.FirstName }} {{ UserPrivateProfile.LastName }}</p>
    </div>
</template>

<script>
    //import services
    import { UserAPI } from '../../../services/api/Core/UserAPI.js';
    //import components
    import Logout from '../../Core/UI/Logout.vue';
    
    export default {
        name: "HomeLayout",
        created() {
            const userAPI = new UserAPI(this.$baseURL);
            this.userAPI = userAPI;
            this.$store.commit("User.PrivateProfile.Clear");
        },
        data: function () {
            return {
                sitelogo: "/images/OliveCrestLogo_Banner_Portal.png",
            };
        },
        methods: {
            
            GetEmployeePrivateProfile() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/User/GetEmployeePrivateProfile", {}, this.GetEmployeePrivateProfileSuccess, () => { }, true);
            },
            GetEmployeePrivateProfileSuccess(response) {
                if (response.data.data == null) {
                    window.location = "/Identity/Account/Login";
                }
                this.$store.commit("User.PrivateProfile.Replace", response.data.data);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            Logout
        },
        mounted() {
            this.GetEmployeePrivateProfile();
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            },
            AppModules: function () {
                //temp: return residential route (direct route) if residential is only option
                let modules = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramModules"]();

                //add option for new Oliver 4 Wraparound portal
                const oliver4WraparoundSubProgramId = "55751c5b-a011-4ffa-8c6e-ac25d7bf9a0c";
                let assignedSubPrograms = this.UserPrivateProfile.AssignedSubPrograms || [];
                let oliver4Wraparound = assignedSubPrograms.find(sp => sp.Id != null && sp.Id.toLowerCase() == oliver4WraparoundSubProgramId);
                if (oliver4Wraparound) {
                    //hide the legacy module tile if it only exists because of the Oliver 4 subprogram
                    let sharesModule = assignedSubPrograms.some(sp => sp !== oliver4Wraparound && sp.WebApplicationModuleName == oliver4Wraparound.WebApplicationModuleName);
                    if (!sharesModule) {
                        modules = modules.filter(m => m.Label != oliver4Wraparound.WebApplicationModuleName);
                    }
                    modules.push({
                        Link: null,
                        ExternalUrl: "https://oliver.olivecrest.org",
                        Label: "NEW Wraparound Portal - Oliver 4",
                        Message: "Find the new Wraparound portal here at https://oliver.olivecrest.org"
                    });
                }
                //add option for file upload and dispatch
                if (this.CheckPermission("FileUploadAndDispatch.ModuleAccess.Pane")) {
                    modules.push({
                        Link: "UserUtilities/FileUploadAndDispatch",
                        Label: "File Upload and Dispatch"
                    });
                }

                //add option for Billing
                if (this.CheckPermission("MentalHealth.Billing.ModuleAccess")) {
                    modules.push({
                        Link: "Billing",
                        Label: "Billing Management"
                    });
                }
                //add admin pane
                if (this.CheckPermission("Administrator")) {
                    modules.push({
                        Link: "Admin",
                        Label: "Admin Panel"
                    });
                }

                if (this.CheckPermission("ExecutiveDashboardAccess")) {
                    modules.push({
                        Link: "ExecutiveCoreDashboard",
                        Label: "Exec Core Dashboard"
                    });
                }

                if (this.CheckPermission("MentalHealth.Appointments")) {
                    modules.push({
                        Link: "Appointments",
                        Label: "Psych Appointments"
                    });
                }

                if (this.CheckPermission("FundDevelopment.ModuleAccess")) {
                    modules.push({
                        Link: "FundDevelopment",
                        Label: "Fund Development"
                    });
                }

                if (this.CheckPermission("QualityManagement.ModuleAccess")) {
                    modules.push({
                        Link: "QualityManagement",
                        Label: "Quality Management"
                    });
                }

                if (this.CheckPermission("OrganizationWideClientSearchAccess")) {
                    modules.push({
                        Link: "ClientSearch",
                        Label: "Client Search"
                    });
                }


                //handle routing for module lengths
                if (modules.length == 1 && modules[0].Link == 'Residential') {
                    //redirect
                    window.location.href = this.$baseURL + '/Residential';
                } else if (modules.length == 1 && !modules[0].ExternalUrl) {
                    this.$router.push({ path: modules[0].Link });
                    return [];
                }
                return modules;
            }
        }
    }
</script>

<style scoped>
    .upper-right {
        position:absolute;
        top:0;
        right:40px;
    }

    .HomeLayout {
        background-color: #605271;
    }
</style>